import "./App.css";
import { ConfigProvider } from "antd";
import SVGtoPNGResizer from "./SVGtoPNGResizer.jsx";
import { antdLocale } from "./i18n";

function App() {
  return (
    <ConfigProvider locale={antdLocale}>
      <div className="App">
        <SVGtoPNGResizer />
      </div>
    </ConfigProvider>
  );
}

export default App;
